<template>
  <el-dialog
    :title="activeItem?.name + '二维码'"
    :visible.sync="$parent.qrCode"
    :before-close="handleClose"
    class="qrCodeDialog"
  >
    <div class="qrCodeContent">
      <div class="qrcode" ref="qrcode" :title="title" v-loading="loading"></div>
      <div class="btnBox">
        <el-row style="margin-bottom: 20px">
          <el-button @click="createPicture" type="primary" plain
            >下载二维码</el-button
          >
        </el-row>
        <el-row>
          <el-button
            type="primary"
            plain
            style="margin-top: 20px"
            @click="generateCode"
            :disabled="disabledBtn"
            >重新生成二维码</el-button
          >
          <p>*重新生成二维码后，原二维码将失效，请谨慎操作！</p>
        </el-row>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="$parent.qrCode = false">取 消</el-button>
    </span>
  </el-dialog>
</template>

<script>
import QRCode from "qrcodejs2";
import api from "@/api";
import { handleCanvasTxt } from "@/assets/utils/handleData.js";
export default {
  props: ["activeItem"],
  data() {
    return {
      qrcode: null,
      imgData: null,
      title: null,
      loading: false,
      disabledBtn: false,
    };
  },
  methods: {
    handleClose() {
      this.$refs.qrcode.innerHTML = "";
      this.qrcode = null;
      this.$parent.qrCode = false;
    },
    async generateCode() {
      this.loading = true;
      this.disabledBtn = true;
      let res = await api.patrolPointEditQrcode({
        id: this.activeItem.id
          ? {
              entityType: "INSPECTION_POINT",
              id: this.activeItem.id,
            }
          : null,
        qrCodeVersion: this.activeItem.qrCodeVersion + 1,
      });
      if (res && res.data.code == 200) {
        setTimeout(() => {
          this.$parent.getList();
          this.loading = false;
          this.creatQrCode(res.data.data.qrCodeVersion);
        }, 1000);
      }
    },
    creatQrCode(num) {
      let _this = this;
      let text = `http://jujiembs.com:59999/?tenantId=${
        JSON.parse(window.sessionStorage.getItem("userInfo")).tenantId
      }&pointId=${this.activeItem.id}&num=${num}`;
      // let text = `${
      //   process.env.NODE_ENV === "production"
      //     ? window.location.origin
      //     : "http://192.168.2.86:9090"
      // }?tenantId=${
      //   JSON.parse(window.sessionStorage.getItem("userInfo")).tenantId
      // }&pointId=${this.activeItem.id}&num=${num}`;
      this.$refs.qrcode.innerHTML = "";
      this.qrcode = new QRCode(this.$refs.qrcode, {
        text: text,
        width: 150,
        height: 150,
        colorDark: "#000000",
        colorLight: "#ffffff",
      });
      setTimeout(() => {
        let srcUrl = document
          .getElementsByClassName("qrcode")[0]
          .getElementsByTagName("img")[0]
          .getAttribute("src");
        let c = this.$refs.qrcode.getElementsByTagName("canvas")[0];
        let ctx = c.getContext("2d");
        ctx.width = 150;
        ctx.height = 150;
        ctx.fillStyle = "#fff";
        ctx.fillRect(0, 0, 150, 150);
        let img1 = new Image();
        img1.src = srcUrl;
        let str = _this.activeItem?.name;
        img1.onload = function () {
          ctx.drawImage(img1, 25, 10, 100, 100);
          ctx.textAlign = "center";
          ctx.fillStyle = "#000000";
          ctx.font = "14px normal";
          // ctx.fillText(_this.activeItem?.name, 75, 140)
          let result = handleCanvasTxt(str);
          for (let i = 0; i <= result.rows; i++) {
            ctx.fillText(
              str.slice(result.rowFontNum * (i - 1), result.rowFontNum * i),
              75,
              105 + i * 20
            );
          }
        };
      }, 100);
      this.title = "";
    },
    createPicture() {
      let canvasData = this.$refs.qrcode.getElementsByTagName("canvas");
      let a = document.createElement("a");
      let event = new MouseEvent("click"); // 创建一个单击事件
      a.href = canvasData[0].toDataURL("image/png");
      a.download = this.activeItem.name; //下载文件名称
      a.dispatchEvent(event); // 触发a的单击事件
    },
  },
  created() {
    let userData = JSON.parse(window.sessionStorage.getItem("userInfo"));
    this.disabledBtn =
      userData.projects[0].pageSettings.findIndex((v) => {
        return v.pageName == "showRefreshQRCode";
      }) !== -1 && userData.identity == "operation"
        ? false
        : true;
    this.$nextTick(() => {
      this.creatQrCode(this.activeItem.qrCodeVersion);
    });
  },
};
</script>

<style lang="scss" scoped>
.qrCodeDialog {
  ::v-deep .el-dialog {
    min-width: 25%;
    max-width: 30%;
    overflow: auto;
  }

  .qrCodeContent {
    width: 100%;
    height: 100%;
    @include setFlexStart;

    .btnBox {
      margin-left: 30px;

      p {
        color: red;
      }
    }
  }
}
</style>
